module.exports = __webpack_public_path__ + "img/top4.a290b77e.png";